const ns_groups = {
	how_to_use_section: `These are all-or-nothing settings. So one name is not and other domain name is, doesn't work.
		Customer has own nameservers? Then they cannot manage their DNS in Portal.
		Customer wants to use our nameservers with their own name?

		Inform an engineer that you are going to do that and let them know the names (e.g. n1.customername.co.uk and ns2.customername.co.uk. Customername.co.uk must be with us!)
		Create a name server group in OXXA with those names
		Wait for the engineer's approval.
		Then add this name server group in Portal and link it to the debtor

		If you do not set anything, the name servers of Tuxis will be used by default, which is the desired setting. 
		If you change this setting in between, it will apply to all new registrations. Old registrations are not changed. 
		So with OXXA, you can also delete a nameserver group.`,
	table: {
		headers: {
			alias: "Alias",
			company: "Company",
			debtor: "Debtor",
			is_external: "Own Nameservers?",
			ns_overview: "Nameserver Overview",
			oxxa_handle: "Oxxa Handle",
		},
	},
	title: "Custom NS Groups", // Custom NS Groups
};

export default ns_groups;
